import Grid from "@material-ui/core/Grid"
import TextField from "@material-ui/core/TextField"
import React from "react"
import BoardConfirmModal from "../ConfirmModal/BoardConfirmModal"
import { useUpdate } from "./hooks"

const Update = () => {
    const {
        callback, cancelCallback, dialogData,
        disabled, dateStr, text, handleChange,
        isBusiness, isMine, isPass, notApp,
        projectId, handleProjectIdChange,
        projectMoney, handleProjectMoneyChange,
    } = useUpdate()
    return (
        <BoardConfirmModal
            title="修改预约说明"
            confirmCallback={callback}
            cancelCallback={cancelCallback}
            modalShow={dialogData.show}
            disabled={disabled}
        >
            <Grid container direction="column" justify="center">
                <div>{dateStr}</div>
                <TextField
                    label="预约说明"
                    value={text}
                    disabled={isPass && isBusiness}
                    onChange={handleChange}
                />
            </Grid>
            {
                // 编辑时，用户为商务部成员且时自己的预约时，展示项目编号及金额
                isBusiness && isMine && notApp ? (
                    <>
                        <Grid container direction="column" justify="center">
                            <TextField
                                label="项目编号"
                                value={projectId}
                                onChange={handleProjectIdChange}
                                error={!!(projectId && projectId.length > 50)}
                                helperText={!!(projectId && projectId.length > 50) ? '最多50英文字符' : undefined}
                            />
                        </Grid>
                        <Grid container direction="column" justify="center">
                            <TextField
                                label="项目金额"
                                value={projectMoney}
                                onChange={handleProjectMoneyChange}
                                error={!!(projectMoney && projectMoney.length > 50)}
                                helperText={!!(projectMoney && projectMoney.length > 50) ? '最多50英文字符' : undefined}
                            />
                        </Grid>
                    </>
                ) : null
            }
        </BoardConfirmModal>
    )
}

export default Update
